<template>
  <section id="services" class="services py-20 bg-gradient-to-r from-primary-400 to-primary-600 text-white relative overflow-hidden">
    <!-- Background Decorative Elements -->
    <div class="absolute top-0 left-0 w-full h-full bg-gradient-to-t from-neutral-900 to-transparent opacity-50"></div>
    <div class="absolute bottom-1/4 left-1/4 w-24 h-24 bg-primary-600 rounded-full opacity-20 animate-pulse"></div>
    <div class="absolute top-1/4 right-1/4 w-36 h-36 bg-primary-600 rounded-full opacity-30 animate-pulse"></div>

    <div class="container mx-auto text-center relative z-10">
      <!-- Section Title -->
      <h2 class="text-4xl sm:text-5xl font-extrabold mb-12 text-yellow-500 animate__animated animate__fadeIn animate__delay-1s">
        Our Services
      </h2>
      <p class="text-lg max-w-3xl mx-auto mb-8">
        Welcome to <strong>Use N Lease</strong> – experience the freedom of renting. We connect individuals and businesses to a diverse world of goods, making it easy to access what you need when you need it. From construction item and vehicles to electronics, furniture, and more, our platform empowers you to rent anything and only buy what you truly need.
      </p>

      <!-- Services List -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-16 px-4">
        <!-- Service Items -->
        <div class="service-item bg-theme-card text-center p-8 rounded-3xl shadow-2xl transform hover:scale-105 transition-all duration-500 relative overflow-hidden">
          <div class="absolute inset-0 bg-gradient-to-r from-primary-600 to-primary-400 opacity-30"></div>
          <i class="pi pi-box text-5xl text-primary-600 mb-6 z-10"></i>
          <h3 class="text-3xl font-semibold mb-3 z-10">Extensive Inventory</h3>
          <p class="text-lg text-theme-text z-10">Access a wide selection of items, from heavy machinery and vehicles to IT item, furniture, and more.</p>
          <div class="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-neutral-900 opacity-20"></div>
        </div>

        <div class="service-item bg-theme-surface text-center p-8 rounded-3xl shadow-2xl transform hover:scale-105 transition-all duration-500 relative overflow-hidden">
          <div class="absolute inset-0 bg-gradient-to-r from-primary-600 to-primary-400 opacity-30"></div>
          <i class="pi pi-calendar text-5xl text-primary-600 mb-6 z-10"></i>
          <h3 class="text-3xl font-semibold mb-3 z-10">Effortless Booking</h3>
          <p class="text-lg text-theme-text z-10">Reserve your desired items quickly and easily through our user-friendly platform.</p>
          <div class="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-neutral-900 opacity-20"></div>
        </div>

        <div class="service-item bg-theme-surface text-center p-8 rounded-3xl shadow-2xl transform hover:scale-105 transition-all duration-500 relative overflow-hidden">
          <div class="absolute inset-0 bg-gradient-to-r from-primary-600 to-primary-400 opacity-30"></div>
          <i class="pi pi-truck text-5xl text-primary-600 mb-6 z-10"></i>
          <h3 class="text-3xl font-semibold mb-3 z-10">Flexible Logistics</h3>
          <p class="text-lg text-theme-text z-10">Enjoy convenient delivery and pickup options tailored to your schedule and location.</p>
          <div class="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-neutral-900 opacity-20"></div>
        </div>

        <div class="service-item bg-theme-surface text-center p-8 rounded-3xl shadow-2xl transform hover:scale-105 transition-all duration-500 relative overflow-hidden">
          <div class="absolute inset-0 bg-gradient-to-r from-primary-600 to-primary-400 opacity-30"></div>
          <i class="pi pi-dollar text-5xl text-primary-600 mb-6 z-10"></i>
          <h3 class="text-3xl font-semibold mb-3 z-10">Transparent Pricing</h3>
          <p class="text-lg text-theme-text z-10">Clear and competitive pricing with no hidden fees for a budget-friendly rental experience.</p>
          <div class="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-neutral-900 opacity-20"></div>
        </div>

        <div class="service-item bg-theme-surface text-center p-8 rounded-3xl shadow-2xl transform hover:scale-105 transition-all duration-500 relative overflow-hidden">
          <div class="absolute inset-0 bg-gradient-to-r from-primary-600 to-primary-400 opacity-30"></div>
          <i class="pi pi-users text-5xl text-primary-600 mb-6 z-10"></i>
          <h3 class="text-3xl font-semibold mb-3 z-10">Dedicated Support</h3>
          <p class="text-lg text-theme-text z-10">Our team provides professional assistance to ensure a smooth rental journey.</p>
          <div class="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-neutral-900 opacity-20"></div>
        </div>
      </div>
    </div>
  </section>
</template>
